<template>
<div class="chapter">
<div class="inner_page">
<p class="C1703"><span id="page_1">“Write </span>to Your Unknown Friends”</p>
<p class="C1704"><em>—Jeff Gundy</em></p>
<p class="C1600">This is for Bob. He’s a good guy, likes</p>
<p class="C1600">to fly fish, records each catch, where</p>
<p class="C1600">he caught it, the weather, type of fly,</p>
<p class="C1606">time of day. He tosses everything back.</p>
<p class="C1600">This is for Tanya. She’s a single mom</p>
<p class="C1600">with three kids. She works behind</p>
<p class="C1600">the counter in the post office, knows</p>
<p class="C1600">everyone in town. Years ago she</p>
<p class="C1600">threw away the “Return to Sender.</p>
<p class="C1606">Address Unknown” stamp.</p>
<p class="C1600">This is for Ted. Ted sells cars.</p>
<p class="C1600">He wishes cars with fins would</p>
<p class="C1600">come back. He knows gas mileage</p>
<p class="C1600">matters. But “You don’t see</p>
<p class="C1606">mileage when a car drives by.”</p>
<p class="C1600">This is for Kenny. He never made it</p>
<p class="C1600">past the sixth grade. In the winter,</p>
<p class="C1600">he plows driveways, shovels walks.</p>
<p class="C1600">The rest of the year he paints houses,</p>
<p class="C1600">mows lawns, hauls junk. Each morning</p>
<p class="C1600">he buys a paper, reads it over a cup</p>
<p class="C1606">of coffee, black, and does the crossword.</p>
<p class="C1600">This is for Ann. In her backyard, she</p>
<p class="C1600">has a perennial garden, best in town,</p>
<p class="C1600">more than a hundred different plants.</p>
<p class="C1600">She has four greyhounds and a parakeet.</p>
<p class="C1600">Wherever she goes, she wears a hat.</p>
<p class="C1600"><span id="page_2">This </span>is for Martha. She talks to</p>
<p class="C1600">sparrows. She tries to tell them</p>
<p class="C1606">something they’ve never heard.</p>
<p class="C1600">This is for Sammy. He’s always late.</p>
<p class="C1600">He loves to play blackjack. He’s</p>
<p class="C1600">no good at counting cards. He wants</p>
<p class="C1600">to own a motorcycle and ride it</p>
<p class="C1600">to places he’s never been—Toledo,</p>
<p class="C1606">Jacksonville, Los Angeles, Maine.</p>
<p class="C1600">Today there’s no one around.</p>
<p class="C1600">Too bad. It’s a good day</p>
<p class="C1600">to call some friends, see if</p>
<p class="C1600">they’d like to come over, shoot</p>
<p class="C1600">the breeze, have some pizza, maybe</p>
<p class="C1600">watch an old movie on TV.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07__Write_t.vue?f7976232